export const FORM_FIELD_KEYS = ['nome', 'empresa', 'cargo', 'whatsapp', 'email', 'cnpj']

export function defaultFieldConfig () {
  return {
    nome: { enabled: true, optional: false },
    empresa: { enabled: true, optional: true },
    cargo: { enabled: true, optional: true },
    whatsapp: { enabled: true, optional: false },
    email: { enabled: true, optional: false },
    cnpj: { enabled: true, optional: true }
  }
}

export function normalizeFieldConfig (raw) {
  const base = defaultFieldConfig()
  const out = { ...base }
  for (const key of FORM_FIELD_KEYS) {
    const src = raw?.[key] || {}
    out[key] = {
      enabled: key === 'nome' ? true : !!src.enabled,
      optional: key === 'nome' ? false : !!src.optional
    }
  }
  if (out.email.optional) out.email.optional = false
  if (out.whatsapp.optional) out.whatsapp.optional = false
  if (!out.email.enabled && !out.whatsapp.enabled) {
    throw new Error('CONTACT_REQUIRED')
  }
  return out
}

export function canDisableField (config, key) {
  if (key === 'nome') return false
  if (key !== 'email' && key !== 'whatsapp') return true
  const other = key === 'email' ? 'whatsapp' : 'email'
  return config[other]?.enabled === true
}

export function canToggleOptional (key) {
  return !['nome', 'email', 'whatsapp'].includes(key)
}

export function publicFormUrl (token) {
  const origin = typeof window !== 'undefined'
    ? window.location.origin
    : ''
  return `${origin}/formulario/${token}`
}

export function iframeSnippet (token) {
  const url = publicFormUrl(token)
  return `<iframe src="${url}" width="100%" height="600" frameborder="0" title="Formulário de contato"></iframe>`
}
